import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns Bootstrap CSS classes for category badges.
 *
 * Usage:
 *   [ngClass]="chemical.category | categoryBadge"              → chemical category classes
 *   [ngClass]="chemical.source | categoryBadge:'source'"       → source type classes
 *   [ngClass]="chemical.signalWord | categoryBadge:'signal'"   → signal word classes
 */
@Pipe({
  name: 'categoryBadge',
  standalone: true
})
export class CategoryBadgePipe implements PipeTransform {
  transform(
    category: string | null | undefined,
    type: 'chemical' | 'source' | 'signal' = 'chemical'
  ): string {
    if (!category) return 'bg-secondary-subtle text-secondary';

    const normalizedCategory = category.toLowerCase();

    switch (type) {
      case 'chemical':
        return this.getChemicalCategoryClass(normalizedCategory);
      case 'source':
        return this.getSourceClass(normalizedCategory);
      case 'signal':
        return this.getSignalWordClass(category.toUpperCase());
      default:
        return 'bg-secondary-subtle text-secondary';
    }
  }

  private getChemicalCategoryClass(category: string): string {
    switch (category) {
      case 'herbicide':
        return 'bg-success-subtle text-success';
      case 'insecticide':
        return 'bg-danger-subtle text-danger';
      case 'fungicide':
        return 'bg-primary-subtle text-primary';
      case 'fertilizer':
        return 'bg-warning-subtle text-warning-emphasis';
      default:
        return 'bg-secondary-subtle text-secondary';
    }
  }

  private getSourceClass(source: string): string {
    switch (source) {
      case 'epa':
        return 'bg-primary-subtle text-primary';
      case 'adn-recommended':
        return 'bg-info-subtle text-info';
      case 'custom':
        return 'bg-warning-subtle text-warning-emphasis';
      default:
        return 'bg-secondary-subtle text-secondary';
    }
  }

  private getSignalWordClass(signalWord: string): string {
    switch (signalWord) {
      case 'CAUTION':
        return 'bg-warning-subtle text-warning-emphasis';
      case 'WARNING':
        return 'bg-orange-subtle text-orange';
      case 'DANGER':
        return 'bg-danger-subtle text-danger';
      default:
        return 'bg-secondary-subtle text-secondary';
    }
  }
}
